// extracted by css-extract-rspack-plugin
export default {"root":"uiq1_a","scheduled":"yCrQTo","scheduled-icon":"OPIIca","scheduledIcon":"OPIIca"};